"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { getCurrentDomain } from "@/lib/domainConfig";

declare global {
  interface Window {
    __VM: any[];
  }
}

export default function ProsperNavigationTracker() {
  const pathname = usePathname();

  useEffect(() => {
    // Only track navigation for tcgfan.com
    const domain = getCurrentDomain(window.location.host);
    if (domain !== "tcgfan") {
      return;
    }

    // Initialize __VM if it doesn't exist
    if (typeof window !== "undefined") {
      window.__VM = window.__VM || [];

      // Trigger navigation event for SPA page changes
      window.__VM.push((admanager: any, scope: any) => {
        try {
          // Check if pageManager and dispatchEvent exist before calling
          if (
            scope?.Instances?.pageManager &&
            typeof scope.Instances.pageManager.dispatchEvent === "function"
          ) {
            console.log("[PROSPER] Navigation tracked for:", pathname);
            // Dispatch the navigated event for page session tracking
            scope.Instances.pageManager.dispatchEvent("navigated");
          }
        } catch (error) {
          console.error("[PROSPER] Error tracking navigation:", error);
        }
      });
    }
  }, [pathname]);

  // This component doesn't render anything
  return null;
}
